import o from "./highrise642.mjs";
import e from "./highrise1592.mjs";
import i from "./highrise1593.mjs";
function n(t, r) {
  return i(e(t, r, o), t + "");
}
export {
  n as default
};
